export const productExtraOptionRequestedByEntities = {
    product: "Producto",
    reference: "Variante",
    order: "Orden"
};
